var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('header-bar',{},[_c('h1',{staticClass:"text-2xl"},[_vm._v("Projects")])]),_c('div',{},[(Object.keys(_vm.activeEntity).length != 0)?_c('project',{attrs:{"entity":_vm.activeEntity},on:{"removeProject":_vm.removeProject,"openEnrichment":_vm.openEnrichment,"openAddTags":_vm.openAddTags}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }